import { useAuthenticatedApiClient } from '@guiker/react-framework'
import { AdminApiClient } from '@guiker/user-shared'

export const useAdminUserApiClient = useAuthenticatedApiClient(AdminApiClient)
